import { reverseFormatCurrency } from '~/common/util/format';

// Helper function to get raw value
export function getRawValue(val: number | string): number {
  if (typeof val === 'number') {
    return val;
  }
  if (typeof val === 'string' && val.trim() !== '') {
    return reverseFormatCurrency(val);
  }
  return 0;
}

// Helper function to calculate remaining term
export function calculateRemainingTerm(
  balanceRaw: number,
  paymentRaw: number,
  maxRemainingTerm: number,
): number {
  if (typeof balanceRaw !== 'number' || typeof paymentRaw !== 'number')
    return 0;
  if (balanceRaw <= 0 && paymentRaw <= 0) return 0;

  if (paymentRaw > 0) {
    const term = Math.ceil(balanceRaw / paymentRaw);
    if (!Number.isFinite(term) || term > maxRemainingTerm) {
      return maxRemainingTerm;
    }
    return term;
  }

  if (balanceRaw > 0) {
    return maxRemainingTerm;
  }
}

export function sanitizeInterestRate(value: string | number): string {
  let sanitizedValue = value.toString().replaceAll(/[^0-9.]/g, '');
  const parts = sanitizedValue.split('.');

  if (parts.length > 1) {
    parts[1] = parts[1].substring(0, 3);
    sanitizedValue = parts.join('.');
  }

  return sanitizedValue;
}
